import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
	BannerWrapper,
	TextContainer,
	Heading,
	SubHeading,
	ImageContainer,
	SliderContainer,
	ChangingTexts,
} from "./style";
import FeaturedAlumni from "./FeaturedAlumni";

import Slider from "react-slick";
import TextTransition, { presets } from "react-text-transition";
import { Helmet } from "react-helmet";

const StudentSuccessBanner = (props) => {
	const {
		header,
		subHeader,
		featured_alumni,
		changingProgramValues,
		sideBg,
		sideFont,
		darkBg,
	} = props;

	const sliderSetting = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		customPaging: () => <div className="custom-dots"></div>,
	};

	const [index, setIndex] = useState(0);

	useEffect(() => {
		const intervalId = setInterval(
			() => setIndex((index) => index + 1),
			4000, // every 3 seconds
		);
		return () => clearTimeout(intervalId);
	}, []);

	return (
		<BannerWrapper>
			<Helmet>
				<link
					rel="stylesheet"
					type="text/css"
					charset="UTF-8"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
				/>
				<link
					rel="stylesheet"
					type="text/css"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
				/>
			</Helmet>
			<TextContainer>
				<Heading>
					{header}
					{` `}
					<ChangingTexts>
						<TextTransition
							text={changingProgramValues[index % changingProgramValues.length]}
							springConfig={presets.wobbly}
							inline={true}
							direction="down"
							delay={0}
						/>
					</ChangingTexts>
				</Heading>
				<SubHeading>{subHeader}</SubHeading>
			</TextContainer>
			<ImageContainer bg={sideBg} font={sideFont}>
				<SliderContainer>
					<Slider {...sliderSetting}>
						{featured_alumni.map((alumni, i) => (
							<FeaturedAlumni
								alumni={alumni}
								key={`alumni-${i}`}
								darkBg={darkBg}
							/>
						))}
					</Slider>
				</SliderContainer>
			</ImageContainer>
		</BannerWrapper>
	);
};

StudentSuccessBanner.propTypes = {
	header: PropTypes.string,
	subHeader: PropTypes.string,
	sideBg: PropTypes.string,
	sideFont: PropTypes.string,
};

StudentSuccessBanner.defaultProps = {
	header: "",
	subHeader: "",
	sideBg: "",
	sideFont: "",
};

export default StudentSuccessBanner;
